import i18next from "i18next";
import { LocalizedString } from "../client";

export function preferedLanguage() {
    switch (i18next.language) {
        case "cs":
        case "sk":
            return "cs";
        default:
            return "en";
    }
}

export function getPrefered(strings: LocalizedString, lang?: string): string {
    lang = lang || preferedLanguage();

    if (!strings) {
        return "";
    }

    if (Object.keys(strings).includes(lang)) {
        return (strings as Record<string, string>)[lang];
    }
    return strings["iv"] || "";
}
